// Align matching fields within each visible product row, including after filtering or variant updates.
(() => {
  if (window.dmCardAlignmentLoaded) return;
  window.dmCardAlignmentLoaded = true;
  let frame;
  const selector = '.product-grid, .resource-list--grid, .resource-list';
  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(align);
  }
  function align() {
    document.querySelectorAll('[data-dm-aligned]').forEach((element) => {
      element.style.removeProperty('min-height');
      element.style.removeProperty('margin-block-start');
      element.removeAttribute('data-dm-aligned');
    });
    const grids = new Map();
    document.querySelectorAll('product-card').forEach((card) => {
      const grid = card.closest(selector);
      if (!grid || !card.getClientRects().length) return;
      if (!grids.has(grid)) grids.set(grid, []);
      grids.get(grid).push(card);
    });
    for (const cards of grids.values()) {
      const rows = new Map();
      for (const card of cards) {
        const top = Math.round(card.getBoundingClientRect().top);
        if (!rows.has(top)) rows.set(top, []);
        rows.get(top).push(card);
      }
      for (const row of rows.values()) {
        if (row.length < 2) continue;
        const stages = [
          (card) => card.querySelector('[ref="productTitleLink"] .text-block'),
          (card) => card.querySelector('product-price'),
        ];
        const keys = [...new Set(row.flatMap((card) => [...card.querySelectorAll('variant-picker [data-dm-option-key]')].map((option) => option.dataset.dmOptionKey)))];
        for (const key of keys) stages.push((card) => [...card.querySelectorAll('variant-picker [data-dm-option-key]')].find((option) => option.dataset.dmOptionKey === key));
        for (const stage of stages) {
          const elements = row.map(stage).filter((element) => element && element.getClientRects().length);
          if (elements.length < 2) continue;
          const rects = elements.map((element) => element.getBoundingClientRect());
          const top = Math.max(...rects.map((rect) => rect.top));
          const height = Math.max(...rects.map((rect) => rect.height));
          elements.forEach((element, index) => {
            const margin = parseFloat(getComputedStyle(element).marginBlockStart) || 0;
            element.style.marginBlockStart = `${margin + top - rects[index].top}px`;
            element.style.minHeight = `${height}px`;
            element.dataset.dmAligned = 'true';
          });
        }
      }
    }
  }
  new MutationObserver((changes) => {
    if (changes.some((change) => change.target instanceof Element && (change.target.closest('product-card, results-list') || [...change.addedNodes].some((node) => node instanceof Element && (node.matches('product-card') || node.querySelector('product-card')))))) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('dm:grid-layout', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('load', (event) => { if (event.target instanceof HTMLImageElement && event.target.closest('product-card')) schedule(); }, true);
  document.fonts?.ready.then(schedule);
  schedule();
})();
